require('../../scss/frontend/timeline.scss');

document.addEventListener("DOMContentLoaded", function (event) {

    const wrapperElement = document.querySelector('#dcs-timeline-wrapper');
    let containerElement = document.querySelector('#dcs-timeline.horizontal');

    if (containerElement) {
        console.log('h-scroll');
        const scrollableElement = document.querySelector('#dcs-timeline.horizontal > div');

        const containerWidth = containerElement.scrollWidth;

        wrapperElement.style.height = (containerWidth - window.innerWidth + containerElement.getBoundingClientRect().height) + 'px';
        const minScroll = 0
        const maxScroll = containerWidth - window.innerWidth;

        window.onscroll = (e) => {
            const position = 120 - wrapperElement.getBoundingClientRect().y;
            const containerSticky = position < minScroll ? 'top' : (position < maxScroll ? 'fixed' : 'bottom');
            const scrollablePosition = -(position < minScroll ? minScroll : (position < maxScroll ? position : maxScroll));

            switch (containerSticky) {
                case 'top':
                    containerElement.style.position = 'relative';
                    containerElement.style.top = 'unset';
                    break;
                case 'fixed':
                    containerElement.style.position = 'fixed';
                    containerElement.style.top = '120px';
                    break;
                case 'bottom':
                    containerElement.style.position = 'relative';
                    containerElement.style.top = `${maxScroll}px`;
                    break;
            }
            scrollableElement.style.transform = `translateX(${scrollablePosition}px)`;
        }
    } else {
        console.log('v-scroll');
        containerElement = document.querySelector('#dcs-timeline.vertical');
        const scrollableElement = document.querySelector('#dcs-timeline.vertical > div');
        const floorElement = document.querySelector('#floor');
        const subfloorElement = document.querySelector('#subfloor');
        floorElement.style.position = 'fixed';
        subfloorElement.style.marginTop = floorElement.getBoundingClientRect().height + 'px';

        const containerHeight = containerElement.scrollHeight;

        wrapperElement.style.height = (containerHeight - window.innerHeight + 100 + containerElement.getBoundingClientRect().height) + 'px';
        const minScroll = 0
        const maxScroll = containerHeight - window.innerHeight + 150;

        window.onscroll = (e) => {
            const position = 120 - wrapperElement.getBoundingClientRect().y;
            const containerSticky = position < minScroll ? 'top' : (position < maxScroll ? 'fixed' : 'bottom');
            const scrollablePosition = -(position < minScroll ? minScroll : (position < maxScroll ? position : maxScroll));

            switch (containerSticky) {
                case 'top':
                    containerElement.style.position = 'relative';
                    containerElement.style.top = 'unset';
                    break;
                case 'fixed':
                    containerElement.style.position = 'fixed';
                    containerElement.style.top = '120px';

                    break;
                case 'bottom':
                    containerElement.style.position = 'relative';
                    containerElement.style.top = `${maxScroll}px`;
                    break;
            }
            floorElement.style.top = (containerElement.getBoundingClientRect().top + containerElement.getBoundingClientRect().height) + 'px';
            scrollableElement.style.transform = `translateY(${scrollablePosition}px)`;
        }
    }
});
